// extracted by mini-css-extract-plugin
module.exports = {"timeAndDate":"TimeAndDate_timeAndDate__W0upy","time":"TimeAndDate_time__1G0GP","date":"TimeAndDate_date__2-Du2"};